import { Section, SectionList, SubTitle, Table } from '@/components/ArticleElement'
import PoliciesLayout from '@/components/Layouts/PoliciesLayout'
import { useLanguage } from '@/hooks/Contexts'
import { Fragment } from 'react'

const PrivacyPolicy = () => {
  const {
    privacy_policy: { main, titles, paragraphs, lists, table },
  } = useLanguage()

  return (
    <PoliciesLayout title='privacy_policy'>
      {main.map((title1, i) => (
        <Fragment key={i}>
          {title1 && <SubTitle extraCls='mt-4'>{title1}</SubTitle>}
          {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(j => (
            <Fragment key={`${i}-${j}`}>
              {titles[i]?.[j] && <SubTitle extraCls='mt-4'>{titles[i][j]}</SubTitle>}

              {paragraphs[i][j] && <Section paragraphs={paragraphs[i][j]} paragraphCls='mt-2' />}

              {lists[i] && lists[i][j] && <SectionList listCls='list-decimal' list={lists[i][j]} />}

              {i === 4 && j === 3 && <Table headers={table.headers} rows={table.rows} extraCls='my-4 shadow-lg shadow-stone-200' />}
            </Fragment>
          ))}
        </Fragment>
      ))}
    </PoliciesLayout>
  )
}

export default PrivacyPolicy
